let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gYu8q")).then(() => parcelRequire('kI6fy'));